<template>
  <router-view />
</template>

<style lang="scss">
$pretty--color-default: #bdc3c7;
$pretty--color-primary: #0a4650;
$pretty--color-info: #35abb0;
$pretty--color-success: #5cb85c;
$pretty--color-warning: #f0ad4e;
$pretty--color-danger: #bd582c;
$pretty--color-dark: #5a656b;

@import 'pretty-checkbox/src/pretty-checkbox.scss';
@import '../vendors/bootstrap-datetimepicker/bootstrap-datetimepicker.css';
@import 'vue-loading-overlay/dist/vue-loading.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';
@import 'vue2-dropzone/dist/vue2Dropzone.min.css';
@import 'dhx-diagram-package/codebase/diagram.css';
@import './scss/AdminLTE_excube';
@import './scss/excube';
@import 'overlayscrollbars/css/OverlayScrollbars.css';
@import '../vendors/tui-editor/tui-editor.css';
@import '../vendors/tui-editor/tui-editor-contents.css';
@import '@toast-ui/editor/dist/toastui-editor.css';
</style>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useStore } from '@/store'

const store = useStore()

store.commit('set_current_env')

const loadScript = (url: string): void => {
  const plugin = document.createElement('script')
  plugin.setAttribute('src', url)
  plugin.async = false
  document.head.appendChild(plugin)
}

onBeforeMount(() => {
  const { BASE_URL } = import.meta.env
  loadScript(`${BASE_URL}static/plugins/adminlte/adminlte.js`)
  loadScript(`${BASE_URL}static/plugins/jquery-ui-1.13.3/jquery-ui.min.js`)
  loadScript(`${BASE_URL}static/plugins/evol-colorpicker/evol-colorpicker.min.js`)
})
</script>
